import type { DeepRequired } from '../fixtures.types'

const miCase: DeepRequired<MiCase> = {
  __typename: 'MICase',
  address: null,
  advisor_id: null,
  case_id: 'TEST_ID',
  case_status: null,
  case_type: null,
  last_editor_type: 'USER',
  client_ids: [],
  clients: [],
  created_at: null,
  credit_report_done: null,
  lender: null,
  lender_id: null,
  related_users: null,
  introducer: null,
  introducer_id: null,
  introducer_user: null,
  related_cases: [],
  property_id: null,
  notes: null,
  flags: null,
  advisor_name: null,
  recommendation_date: null,
  offer_date: null,
  exchange_date: null,
  review_date: null,
  submitted_date: null,
  completed_date: null,
  first_recommendation_date: null,
  first_offer_date: null,
  first_exchange_date: null,
  first_review_date: null,
  first_submitted_date: null,
  first_completed_date: null,
  regulated_by_name: null,
  logged_in_to_client_portal: null,
  recent_client_doc: false,
  meeting_booked: null,
  modified_at: null,
  mortgage_amount: null,
  org_id: null,
  org_ids: [],
  organisation_name: null,
  predicted_revenue: null,
  transition_at: null,
  introducerClients: [],
  offer_expiry_date: null,
  organisation: null,
}

export default miCase
